module.exports = __webpack_public_path__ + "img/b_2.00a858d9.jpg";